<template>
  <div class="header__search">
    <div class="header-search__mnav nav-sections">
      <span class="nav-sections__button" @click="mNavSearch = !mNavSearch">
        <svg width="32" height="32">
          <use xlink:href="#loupe" />
        </svg>
      </span>
    </div>

    <div
      class="search-form"
      :class="{ _shrinked: isShrinked && !mNavSearch, _m_show: mNavSearch }"
    >
      <div class="search-form__input-wrapper">
        <search-by
          ref="searchBy"
          :default-value="query.searchBy"
          @change="onSearchByChange"
        />

        <input
          ref="searchInput"
          :value="query.text"
          type="text"
          name="search"
          class="search-form__input"
          autocorrect="off"
          spellcheck="false"
          autocomplete="off"
          placeholder="поиск документов"
          @input="onInputChange"
          @focus="onInputFocus"
          @blur="onInputBlur"
          @keydown.esc="cleanQueryText"
          @keydown.enter.exact.prevent
          @keyup.enter.exact="onSubmit"
          @keydown.enter.shift.exact="onSubmit"
        />

        <span class="search-form__options">
          <svg
            v-if="!query.text"
            class="search-form__loupe"
            width="24"
            height="24"
          >
            <use xlink:href="#loupe" />
          </svg>

          <svg
            v-else
            class="search-form__cross"
            width="24"
            height="24"
            @click="cleanQueryText"
          >
            <use xlink:href="#cross" />
          </svg>
        </span>

        <div
          v-show="historyOpened"
          class="search-form__history"
          @mouseover="onHistoryOver"
          @mouseout="onHistoryOut"
        >
          <search-history @historyItemSelected="handleHistorySelected" />
        </div>
      </div>

      <button 
        class="search-form__submit" 
        @click="onSubmit"
      >
        Поиск
      </button>
    </div>  

    <div class="header-search__filters nav-sections">
      <nav-button
        v-for="(button, k) in buttonsConfig"
        :key="`${k}_${button.buttonType}`"
        :buttonType="button.buttonType"
        :title="button.title"
        :isActive="sidebarStatus === button.buttonType"
        @setNewStatus="onMenuButtonClick(button.buttonType)"
      />
    </div>
    
    <div class="header-search__filters nav-sections">
      <router-link
        tag="button"
        to="/dictionary"
        class="nav-sections__button"
        active-class="_active"
        title="Словарь терминов"
      >
        <svg width="32" height="32">
          <use xlink:href="#dictionary" />
        </svg>
      </router-link>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

import { mapState, mapGetters } from 'vuex';
import { ROUTE_SEARCH } from '@src/routes';

import SearchBy from './SearchBy';
import SearchHistory from './SearchHistory';
import NavButton from './NavButton';

const BUTTONS_CONFIG = [
  { buttonType: 'filter', title: 'Поисковый фильтр' },
  { buttonType: 'classifiers', title: 'Классификаторы' },
  { buttonType: 'checklists', title: 'Перечни' }
];

export default {
  components: {
    SearchBy,
    SearchHistory,
    NavButton
  },

  data() {
    return {
      query: {
        text: '',
        searchBy: 'designation'
      },
      buttonsConfig: BUTTONS_CONFIG,
      inputFocus: false,
      historyFocus: false,
      mNavSearch: false
    };
  },

  computed: {
    ...mapGetters([
      'searchQuery',
      'searchQueryText',
      'sidebarStatus',
      'searchHistory'
    ]),
    isShrinked() {
      return !this.inputFocus && !this.query.text && !this.historyFocus;
    },
    historyOpened() {
      return (
        (this.inputFocus || this.historyFocus) && !!this.searchHistory.length
      );
    }
  },

  watch: {
    searchQueryText: function(newStr) {
      this.query.text = newStr;
    }
  },

  mounted() {
    this.query.text = this.searchQuery.text;
    this.query.searchBy = this.searchQuery.searchBy;
    if (this.$refs.searchBy) {
      this.$refs.searchBy.setValue(this.query.searchBy);
    }
    this.mNavSearch = false;
    this.$store.dispatch('loadSearchHistory');
  },

  methods: {
    onInputChange(e) {
      const value = e.target.value;
      this.query.text = value.replace(/[\r\n\t]+/gm, '').trim();
    },
    async onSubmit() { 
      this.$store.dispatch('setTextQueryParams', {
        text: this.query.text,
        searchBy: this.query.searchBy
      });
      if (this.$route.name !== ROUTE_SEARCH) {
        // Обнуление значений запроса при переходе на страницу запроса с другой страницы
        if (!this.query.text) {
          await this.$store.dispatch('resetRequest');
        }
        this.$router.push({ 
          name: ROUTE_SEARCH,
          query:{
            request: this.query.text
          }
        });
      } else {
        this.$router.push({ 
          query:{
            request: this.query.text
          }
        });
      }
      this.$refs.searchInput.blur();
      this.mNavSearch = false; // убираем строку поиска в моб.версии
    },
    handleHistorySelected(query) {
      this.query.text = query.text;
      this.query.searchBy = query.searchBy;
     // if (this.$route.name !== ROUTE_SEARCH)
        this.$router.push({ 
          name: ROUTE_SEARCH,
          query:{
            request: this.query.text
          }
        });
    },
    onSearchByChange(searchBy) {
      this.query.searchBy = searchBy;
      this.$refs.searchInput.focus();
    },
    onInputFocus() {
      this.inputFocus = true;
    },
    onInputBlur() {
      this.inputFocus = false;
    },
    onHistoryOver() {
      this.historyFocus = true;
    },
    onHistoryOut() {
      this.historyFocus = false;
    },
    cleanQueryText() {
      let searchInput = this.$refs.searchInput;
      searchInput.focus();
      this.query.text = '';
    },
    async onMenuButtonClick(statusName) {
      this.$store.dispatch('setSidebarStatus', statusName);
      if (this.$route.name !== ROUTE_SEARCH) {
        // Обнуление значений запроса при переходе на страницу запроса с другой страницы
        if (!this.query.text) {
          await this.$store.dispatch('resetRequest');
        }
        this.$router.push({ name: ROUTE_SEARCH });
      }
    }
  }
};
</script>
